import Vue from 'vue';
import Schema from './Schema.vue';
import UniqueFields from './UniqueFields.vue';
export default Vue.extend({
    name: "CollapsableSettings",
    components: { Schema, UniqueFields },
    props: {
        uniqueFields: { type: Array, default: () => [] },
        schema: { type: Array, default: () => [] },
    },
    data() {
        return {
            activePanels: [],
        };
    }
});
